import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHeart, FiShield, FiHelpCircle } = FiIcons;

const Contact = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="text-center mb-12"
      >
        <h1 className="text-4xl md:text-5xl font-bold gradient-text mb-2">
          Contact & Support
        </h1>
        <h2 className="text-xl font-medium mb-4 kaas-subtitle">
          KAAS – Kindness as a Service
        </h2>
        <p className="text-xl text-text mb-8 max-w-2xl mx-auto">
          Have questions, suggestions, or need support? We're here to help make 
          Nakamoto Verse a safe and positive space for everyone.
        </p>
      </motion.div>

      <div className="space-y-8">
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.5 }}
          className="clay-card bg-white p-6"
        >
          <div className="flex items-center space-x-3 mb-4">
            <div className="clay-button p-3">
              <SafeIcon icon={FiHelpCircle} className="text-xl text-accent-dark" />
            </div>
            <h3 className="text-lg font-semibold text-heading">Frequently Asked Questions</h3>
          </div>
          <div className="space-y-4">
            <div>
              <h4 className="font-medium text-heading mb-1">What if I lose my Kindness ID?</h4>
              <p className="text-sm text-text">
                Unfortunately, there's no way to recover a lost ID. You'll need to generate a new one. 
                We recommend bookmarking the page or writing down your ID.
              </p>
            </div>
            <div>
              <h4 className="font-medium text-heading mb-1">How are messages moderated?</h4>
              <p className="text-sm text-text">
                All messages go through automated profanity filtering and manual review before 
                appearing in the public gallery.
              </p>
            </div>
            <div>
              <h4 className="font-medium text-heading mb-1">Is my data safe?</h4>
              <p className="text-sm text-text">
                We don't collect personal information. Your Kindness ID is stored only on your device, 
                and messages are anonymous.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="clay-card bg-white p-6"
        >
          <div className="flex items-center space-x-3 mb-4">
            <div className="clay-button p-3">
              <SafeIcon icon={FiShield} className="text-xl text-accent-dark" />
            </div>
            <h3 className="text-lg font-semibold text-heading">Report Inappropriate Content</h3>
          </div>
          <p className="text-text text-sm mb-4">
            If you encounter content that violates our community guidelines, please let us know immediately.
          </p>
          <div className="space-y-2 text-sm">
            <p className="text-text">• Harmful or threatening messages</p>
            <p className="text-text">• Spam or inappropriate content</p>
            <p className="text-text">• Content that bypassed our filters</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
          className="clay-card bg-gradient-to-r from-primary/20 to-secondary/20 p-6"
        >
          <div className="flex items-center space-x-3 mb-4">
            <div className="clay-button p-3">
              <SafeIcon icon={FiHeart} className="text-xl heart-logo" />
            </div>
            <h3 className="text-lg font-semibold text-heading">Australian Mental Health Resources</h3>
          </div>
          <div className="space-y-2 text-sm">
            <p className="text-text">🆘 Lifeline Australia: 13 11 14</p>
            <p className="text-text">💬 Poison Information Centre: 13 11 26</p>
            <p className="text-text">🌐 Beyond Blue: 1300 22 4636</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;